import React from 'react';

const Divider = ({ title }) => {
    return (
        <h2 className="text-5xl text-center divider my-12 font-bold">{title}</h2>
    );
};

export default Divider;